module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/flow_arrow-adc31df24d053279ff079f690ab6f93f.svg";